import {
  useEnrollMemberInKindbridgeMutation,
  useManuallyPassMemberMutation,
  useResetMemberPasswordMutation
} from '@bo-services/members/membersApi';
import { useCallback } from 'react';

export const useMemberHeaderKebabActions = () => {
  const [
    resetMemberPassword,
    { isLoading: isRPLoading, isError: isRPError, isSuccess: isRPSuccess }
  ] = useResetMemberPasswordMutation();
  const [
    enrollInKindbridge,
    { isLoading: isEKLoading, isError: isEKError, isSuccess: isEKSuccess }
  ] = useEnrollMemberInKindbridgeMutation();
  const [
    manuallyPassMember,
    { isLoading: isMPMLoading, isError: isMPMError, isSuccess: isMPMSuccess }
  ] = useManuallyPassMemberMutation();

  // Reset Member Password Actions
  const handleSubmitResetPassword = useCallback(
    async (email?: string) => {
      if (!email) {
        throw new Error('Email is required');
      }

      await resetMemberPassword({ email }).unwrap();
    },
    [resetMemberPassword]
  );

  // Enroll Member in Kindbridge Actions
  const handleSubmitEnrollKindbridge = useCallback(
    async (memberId?: string) => {
      if (!memberId) {
        throw new Error('Member ID is required');
      }

      await enrollInKindbridge({ id: memberId }).unwrap();
    },
    [enrollInKindbridge]
  );

  // Manually Pass Member Actions
  const handleSubmitManuallyPassMember = useCallback(
    async (memberId?: string) => {
      if (!memberId) {
        throw new Error('Member ID is required');
      }

      await manuallyPassMember({ member_id: memberId }).unwrap();
    },
    [manuallyPassMember]
  );

  const isActionError = isRPError || isEKError || isMPMError;
  const isActionSuccess = isRPSuccess || isEKSuccess || isMPMSuccess;
  const isButtonDisabled = isRPLoading || isEKLoading || isMPMLoading;

  return {
    isActionError,
    isActionSuccess,
    isButtonDisabled,
    onSubmitEnrollKindbridge: handleSubmitEnrollKindbridge,
    onSubmitManuallyPassMember: handleSubmitManuallyPassMember,
    onSubmitResetPassword: handleSubmitResetPassword
  };
};
